import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoiceMid: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconVoiceMid"><Path d="M7.75 5.75V18.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M3.75 10.75V13.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M12 9.75V14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M16.25 7.75V16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M20.25 10.75V13.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconVoiceMid;
